import React from 'react'

// Constants
import { routes } from '@sketch/constants'

// Utils
import { useBreakpoint } from '@sketch/components'

// Styles
import {
  Wrapper,
  EditIcon,
  Text,
  StyledLink,
} from './EditingProfileNavBar.styles'

interface EditingProfileNavBarProps {
  workspaceIdentifier: string
}

export const EditingProfileNavBar: React.FC<EditingProfileNavBarProps> = ({
  workspaceIdentifier,
}) => {
  const isMobile = !useBreakpoint('xs')

  return (
    <Wrapper>
      {isMobile ? (
        <Text>Changes are applied immediately.</Text>
      ) : (
        <>
          <EditIcon />
          <Text>
            Changes you make to your public profile are applied immediately.
          </Text>
        </>
      )}

      <StyledLink
        variant="tertiary"
        to={routes.WORKSPACE_PROFILE.create({
          workspaceId: workspaceIdentifier,
        })}
        isUnderlined
      >
        See Profile
      </StyledLink>
    </Wrapper>
  )
}
